// Base URL for backend API (from environment variable or default)
export const BACKEND_API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8443';

export const API_ENDPOINTS = {
  HEALTH: '/api/health',
  CONSTANTS: '/constants',
  
  // Validators
  VALIDATORS: '/api/validators',
  VALIDATOR_BY_ADDRESS: (address: string): string => `/api/validators/${address}`,
  DELEGATIONS: (address: string): string => `/api/delegations/${address}`,
  STAKING_INFO: '/api/staking/info',
  
  // Governance
  PROPOSALS: '/api/proposals',
  PROPOSAL_BY_ID: (id: string): string => `/api/proposals/${id}`,
  PROPOSAL_VOTE: (proposalId: string, voterAddress: string): string => 
    `/api/proposals/${proposalId}/votes/${voterAddress}`,
  
  // Auctions
  AUCTIONS: '/auctions',
  AUCTION_PERIOD: '/auctions/period',
  AUCTION_PARAMS: '/auctions/params',
  
  // Bridge
  BRIDGE_PENDING_SENDS: (address: string): string => `/api/bridge/pending-sends/${address}`,
  BRIDGE_PENDING_BATCHES: '/api/bridge/pending-batches',
  BRIDGE_TX_STATUS: (txHash: string): string => `/api/bridge/tx-status/${txHash}`,
  BRIDGE_ETH_DEPOSITS: (address: string): string => `/api/bridge/eth-deposits/${address}`,
  BRIDGE_ETH_TX_STATUS: (txHash: string): string => `/api/bridge/eth-tx-status/${txHash}`,
  
  // Stats
  STATS_CHAIN: '/api/stats/chain',
  STATS_AUCTIONS: '/api/stats/auctions',
  STATS_BRIDGE: '/api/stats/bridge',
  STATS_STAKING: '/api/stats/staking',
  
  // Tokens (for solar system visualization)
  TOKENS_ORBITING: (count?: number): string => 
    count !== undefined ? `/tokens/orbiting?count=${count}` : '/tokens/orbiting',
  TOKENS_CENTER: '/tokens/center',

  // CSV Export
  EXPORT_REQUEST: '/api/export/request',
  EXPORT_DOWNLOAD: (token: string): string => `/api/export/download/${token}`,
} as const;
